import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { api } from "../../lib/api";
import { BigButton, StepTitle } from "./KycShell";

const Tarjeta = ({ id, checked, onChange, color, children, extra }) => (
  <div className={`rounded-2xl border bg-white transition-[border-color,box-shadow] duration-200 ${checked ? "shadow-sm" : "border-slate-200"}`}
    style={checked ? { borderColor: color } : undefined} data-testid={`${id}-box`}>
    <label htmlFor={id} className="flex gap-3 items-start p-4 cursor-pointer select-none">
      <input id={id} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="peer sr-only" data-testid={`${id}-checkbox`} />
      <span className="mt-0.5 h-6 w-6 shrink-0 rounded-lg border-2 grid place-items-center transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2"
        style={checked ? { background: color, borderColor: color } : { borderColor: "#CBD5E1" }}>
        {checked && <Check size={16} className="text-white" strokeWidth={3} />}
      </span>
      <span className="text-sm text-slate-700 leading-relaxed">{children}</span>
    </label>
    {extra}
  </div>
);

const Detalle = ({ items, sub }) => {
  const [ver, setVer] = useState(false);
  return (
    <div className="px-4 pb-4 pl-[3.25rem]">
      <button type="button" onClick={() => setVer(!ver)} className="text-xs font-medium underline text-slate-600" aria-expanded={ver} data-testid="consent-biometria-detalle-toggle">
        {ver ? "Ocultar detalle" : "Ver detalle"}
      </button>
      {ver && (
        <ol className="kyc-in mt-3 space-y-2 list-decimal pl-4 text-xs text-slate-500 leading-relaxed" data-testid="consent-biometria-detalle">
          {items.map((d) => <li key={d}>{sub(d)}</li>)}
        </ol>
      )}
    </div>
  );
};

export const StepConsent = ({ brand, onSubmit, busy, didit }) => {
  const [txt, setTxt] = useState(null);
  const [full, setFull] = useState(false);
  const [datos, setDatos] = useState(false);
  const [bio, setBio] = useState(false);
  useEffect(() => {
    api.get("/public/privacidad").then((r) => setTxt(r.data));
  }, []);
  if (!txt) return null;
  const sub = (s) => s.replaceAll("{empresa}", brand.nombre);
  const c = txt.consentimientos;
  return (
    <div className="space-y-4" data-testid="kyc-step-consent">
      <StepTitle title="Antes de empezar" />
      <p className="text-sm text-slate-600 leading-relaxed" data-testid="privacy-summary">{sub(txt.aviso.resumen)}</p>
      <button type="button" onClick={() => setFull(!full)} className="text-xs font-medium underline text-slate-600" data-testid="privacy-toggle-full">
        {full ? "Ocultar aviso completo" : "Leer el aviso completo"}
      </button>
      {full && <pre className="kyc-in whitespace-pre-wrap font-sans text-xs text-slate-500 bg-slate-50 rounded-2xl p-4 max-h-72 overflow-y-auto" data-testid="privacy-full">{sub(txt.aviso.texto)}</pre>}
      <div className="space-y-3 pt-2">
        <Tarjeta id="consent-datos" checked={datos} onChange={setDatos} color={brand.color}>{sub(c.datos)} <b className="text-slate-900">(obligatorio)</b></Tarjeta>
        {didit && (
          <Tarjeta id="consent-biometria" checked={bio} onChange={setBio} color={brand.color} extra={<Detalle items={c.biometria_detalle} sub={sub} />}>
            {sub(c.biometria)}
          </Tarjeta>
        )}
      </div>
      {didit && (
        <p className="text-xs text-slate-500" data-testid="didit-links">
          Lee el <a className="underline" href={c.biometria_links.aviso_didit} target="_blank" rel="noreferrer">aviso de privacidad de Didit</a> y sus{" "}
          <a className="underline" href={c.biometria_links.terminos_didit} target="_blank" rel="noreferrer">términos para usuarios finales</a>.
        </p>
      )}
      <button type="button" disabled={!datos || busy} className="text-xs text-slate-500 underline disabled:opacity-50"
        onClick={() => onSubmit({ acepta_datos: datos, acepta_biometria: false, videollamada: true, version: c.version })} data-testid="consent-videollamada-link">
        ¿Prefieres no usar verificación facial? Verifícate por videollamada
      </button>
      <div className="sticky bottom-0 -mx-5 px-5 pt-3 bg-white/95 backdrop-blur border-t border-slate-100" style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}>
        <BigButton color={brand.color} disabled={!datos || busy || (didit && !bio)} onClick={() => onSubmit({ acepta_datos: datos, acepta_biometria: didit && bio, version: c.version })} data-testid="consent-continue-button">
          Aceptar y continuar
        </BigButton>
      </div>
    </div>
  );
};
